// extracted by mini-css-extract-plugin
export default {"confirmModal":"Confirm_confirmModal__CZeHM"};